import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

/** Matches PATCH /users/:id body fields */
export interface AdminUpdateUserPayload {
  id: string;
  first_name: string;
  last_name: string;
  email?: string;
}

const UsersUpdateSlicer = createSlice({
  name: "UsersUpdate",
  initialState: { isLoading: false, data: {} } as IReduxState,
  reducers: {
    updateUser(state, _action: PayloadAction<AdminUpdateUserPayload>) {
      state.isLoading = true;
    },
    successUpdateUser(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateUser(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    clearUpdateUserState(state) {
      state.isLoading = false;
      state.data = {};
    },
  },
});

export const {
  updateUser,
  successUpdateUser,
  failureUpdateUser,
  clearUpdateUserState,
} = UsersUpdateSlicer.actions;

export default UsersUpdateSlicer.reducer;
